const MEXICO_CITY_TIMEZONE = 'America/Mexico_City'

export {
    MEXICO_CITY_TIMEZONE
}